<template>
  <div class="common-card">
    <modal-approval
      :approve-data="approveData"
      :project_progress_number="project_progress_number"
      :approvalStatusOptions="approvalStatusOptions"
      @refetch-data="refetchData"
    />
    <b-card class="top mb-0" v-if="!in_approve">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon class="mr-50" icon="fa-solid fa-chart-simple" />
            進度資料
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
          <!-- <div class="ml-0 ml-sm-2 mobile-w100 mt-1 d-flex align-items-center mt-sm-0">
            <label>過濾：</label>
            <v-select
              v-model="filter_project_progress_status_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="progressStatusOptions"
              label="name"
              :clearable="false"
              :reduce="(option) => option.id"
              placeholder="選擇狀態"
            />
          </div> -->
        </div>
        <div class="d-flex mobile-w100 flex-wrap mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋進度"
          />
          <b-button class="mobile-w100" :to="{ name: 'progress-create' }"  v-if="ability.can('create', 'progresses')">
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refProgressListTable"
          class="position-relative"
          :items="fetchProgresses"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: approve_status -->
          <template #cell(approve_status)="data">
            <a
              href="javascript:void(0)"
              @click="handleApproval(data.item)"
              class="d-flex align-items-center"
              :style="{ color: getApprove(data.item.approve_status_id).color }"
            >
                <feather-icon class="mr-25" icon="EditIcon" />
              {{ getApprove(data.item.approve_status_id).name }}
            </a>
          </template>

          <template #cell(modifier)="data">
            {{
              data.item.modifier &&
              (data.item.modifier.name ||
                data.item.modifier.name_cn ||
                data.item.modifier.company_name_en ||
                data.item.modifier.company_name_cn)
            }}
          </template>

          <!-- Column: created_at -->
          <template #cell(created_at)="data">
            <div class="d-flex">
              {{ getDateTime(data.item.created_at) }}
            </div>
          </template>

          <!-- Column: salary_items -->
          <template #cell(show_details)="row">
            <b-button
              v-if="row.item.salary_items"
              size="sm"
              @click="row.toggleDetails()"
              class="mr-2"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
            </b-button>
          </template>

          <template #row-details="row">
            <div class="info-container">
              <b-row
                class="p-2 backgroundColor5 mb-1"
                v-for="(worker, index) in row.item.salary_items"
                :key="`cost${index}`"
              >
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label">師傅：</b>
                    <span>{{
                      workerOptions.length > 0 &&
                      workerOptions.filter(
                        (ele) => ele.id == worker.worker_id
                      )[0].name_cn
                    }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">職位：</b>
                    <span>{{ worker.position }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">工資：</b>
                    <span
                      >{{ worker.working_days }}天 * ${{
                        worker.day_salary
                      }}每日 = ${{ worker.total_salary }}</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label">開工日期：</b>
                    <span>{{ formatWorkingDate(worker.working_date) }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="info-container">
              <b-row
                class="p-2 backgroundColor3 mb-1"
                v-for="(cost, index) in row.item.cost_items"
                :key="`cost${index}`"
              >
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label">商品：</b>
                    <span>{{ getProduct(cost.product_id).product_name }}</span>
                  </div>

                  <div class="row mb-50">
                    <b class="label">金額：</b>
                    <span
                      >{{ cost.quantity + getProduct(cost.product_id).unit }} *
                      ${{ cost.unit_price }} = ${{ cost.amount }}</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label">備註：</b>
                    <pre>{{ cost.item_description }}</pre>
                  </div>
                </b-col>
              </b-row>
            </div>
          </template>
        


          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                progressList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="ability.can('read', 'progresses')"
                :to="{
                  name: 'progress-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'progresses')"
                :to="{
                  name: 'progress-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'progresses')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useProgressList from "./useProgressList";
import progressStoreModule from "../progressStoreModule";
import ModalApproval from "../modal/ModalApproval.vue";
import { formatWorkingDate } from "@/utils/dateFormatter";

export default {
  components: {
    ModalApproval,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
      items_key: "",
      current_row: null,
      approveData: null,
      project_progress_number: null,
    };
  },
  props: {
    in_approve: {},
  },
  methods: {
    getProject(id) {
      return (
        this.projectOptions.length > 0 &&
        this.projectOptions.filter((ele) => ele.id == id)[0]
      );
    },
    handleApproval(item) {
      this.approveData = {
        id: item.id,
        approve_status_id: item.approve_status_id,
      };
      this.project_progress_number = item.project_progress_number;
      this.$bvModal.show("modal-approval");
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("progress/deleteProgress", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },

    formatWorkingDate,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "progress";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, progressStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const getProduct = (id) => {
      if (id) {
        const obj =
          productOptions.value &&
          productOptions.value.length > 0 &&
          productOptions.value.filter((ele) => ele.id == id)[0];
        return { ...{ unit: "次" }, ...obj };
      } else {
        return { unit: "次" };
      }
    };

    const getApprove = (id) => {
      if (id) {
        const obj =
          approvalStatusOptions.value &&
          approvalStatusOptions.value.length > 0 &&
          approvalStatusOptions.value.find((ele) => ele.id == id);
        return { ...obj };
      } else {
        return "- -";
      }
    };

    const {
      fetchProgresses,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      progressList,
      refProgressListTable,
      ability,
      refetchData,
      projectOptions,
      productOptions,
      workerOptions,
      approvalStatusOptions,
      filter_project_progress_status_id,
    } = useProgressList();

    return {
      fetchProgresses,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      progressList,
      refProgressListTable,
      ability,
      refetchData,
      projectOptions,
      productOptions,
      workerOptions,
      approvalStatusOptions,
      filter_project_progress_status_id,
      getProduct,
      getApprove,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
    